// extracted by mini-css-extract-plugin
var _1 = "estimate-content__dIW_4";
var _2 = "estimate-footer__79xsY";
var _3 = "estimate-header__NqV3b";
var _4 = "estimate-header-text__TIORN";
export { _1 as "estimateContent", _2 as "estimateFooter", _3 as "estimateHeader", _4 as "estimateHeaderText" }
